import $ from 'jquery';

$(document).ready(function () {
  $('.tab-button').on('click', function () {
    const tab = $(this).data('tab');
    if ($(this).hasClass('is-active')) return;
    $('.tab-button').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-content.is-active')
      .stop(true, true)
      .fadeOut(350, function () {
        $(this).removeClass('is-active');
        $('.tab-content[data-tab="' + tab + '"]')
          .addClass('is-active')
          .fadeIn(350);
      });
  });
  function isScrolledIntoView(elem) {
    const docViewTop = $(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();
    const elemTop = $(elem).offset().top;
    const elemBottom = elemTop + $(elem).outerHeight();
    return elemTop < docViewBottom && elemBottom > docViewTop;
  }

  $(window).on('scroll load', function () {
    const video = $('.tab-video.single').get(0);
    if (!video) return;
    if (isScrolledIntoView('.tabs-images')) {
      if (video.paused) {
        video.muted = true;
        video.play();
      }
    } else {
      if (!video.paused) {
        video.pause();
        video.muted = false;
      }
    }
  });
});
